import type { CmmdThreadDisposition, PutCmmdThreadDispositionParams } from "@cmmd-forge/contracts";

import { request, type TransportConfig } from "./transport";

export interface ThreadDispositionApi {
  putThreadDisposition(
    runtimeId: string,
    projectId: string,
    threadId: string,
    params: PutCmmdThreadDispositionParams,
  ): Promise<CmmdThreadDisposition>;
}

function dispositionPath(runtimeId: string, projectId: string, threadId: string): string {
  return `/api/cmmd/threads/${encodeURIComponent(runtimeId)}/${encodeURIComponent(projectId)}/${encodeURIComponent(threadId)}/disposition`;
}

function putThreadDisposition(
  cfg: TransportConfig,
  runtimeId: string,
  projectId: string,
  threadId: string,
  params: PutCmmdThreadDispositionParams,
): Promise<CmmdThreadDisposition> {
  return request<CmmdThreadDisposition>(
    { method: "PUT", path: dispositionPath(runtimeId, projectId, threadId), body: params },
    cfg,
  );
}

export function bindThreadDispositionApi(
  cfg: TransportConfig,
): ThreadDispositionApi["putThreadDisposition"] {
  return (runtimeId, projectId, threadId, params) =>
    putThreadDisposition(cfg, runtimeId, projectId, threadId, params);
}
